export default __webpack_public_path__ + "static/media/0x31042a4e66eda0d12143ffc8cc1552d611da4cba.59a846af.webp";